import { BsFillPersonLinesFill } from "react-icons/bs";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import {
  EMAIL,
  GITHUB_URL,
  LINKEDIN_URL,
  RESUME_URL,
} from "../utils/constants";

export const socials = [
  {
    id: 1,
    name: "LinkedIn",
    icon: <FaLinkedin size={30} />,
    href: LINKEDIN_URL,
    style: "rounded-tr-md bg-blue-600",
  },
  {
    id: 2,
    name: "Github",
    icon: <FaGithub size={30} />,
    href: GITHUB_URL,
    style: "bg-[#333333]",
  },
  {
    id: 3,
    name: "Email",
    icon: <HiOutlineMail size={30} />,
    href: EMAIL,
    style: "bg-[#6fc2b0]",
  },
  {
    id: 4,
    name: "Resume",
    icon: <BsFillPersonLinesFill size={30} />,
    href: RESUME_URL,
    style: "rounded-br-md bg-[#565f69]",
  },
];

/*
this can also be done for a property inside object
child: (
      <>
        Github <FaGithub size={30} />
      </>
  ),
*/
